import React from 'react';

const PALETTE = [
    'bg-teal-100 text-teal-800',
    'bg-sky-100 text-sky-800',
    'bg-violet-100 text-violet-800',
    'bg-amber-100 text-amber-800',
    'bg-rose-100 text-rose-800',
    'bg-emerald-100 text-emerald-800',
];

export const userName = (login: string): string => login;

export const userEmail = (login: string): string | undefined => undefined;

const initials = (login: string) =>
    login
        .split(/[.\s_-]+/)
        .filter(Boolean)
        .map((p) => p.charAt(0).toUpperCase())
        .slice(0, 2)
        .join('');

const tone = (login: string) => PALETTE[Array.from(login).reduce((acc, c) => acc + c.charCodeAt(0), 0) % PALETTE.length];

export const UserAvatar: React.FC<{ login: string; size?: 'sm' | 'md' }> = ({ login, size = 'sm' }) => (
    <span
        title={userName(login)}
        className={`rounded-full font-semibold flex items-center justify-center ring-2 ring-white dark:ring-slate-800 shrink-0 ${tone(login)} ${
            size === 'sm' ? 'w-7 h-7 text-[11px]' : 'w-9 h-9 text-xs'
        }`}
    >
        {initials(login)}
    </span>
);

export const UserAvatarStack: React.FC<{ logins: string[]; max?: number }> = ({ logins, max = 4 }) => {
    if (!logins.length) return <span className="text-xs text-gray-400">Sem membros</span>;
    return (
        <div className="flex items-center">
            <div className="flex -space-x-2">
                {logins.slice(0, max).map((login) => (
                    <UserAvatar key={login} login={login} />
                ))}
            </div>
            {logins.length > max && <span className="ml-2 text-xs text-gray-500">+{logins.length - max}</span>}
        </div>
    );
};
